import Firebase from 'firebase/app';
import 'firebase/firestore';
import { captureException } from '@sentry/browser';
import { getAuthSessionId } from '@/plugins/auth-storage';
import { ensureFirebaseAuthSession } from '@/plugins/firebase-auth-session';
// Firebaseの本人確認が完了するまで、保存済みWorkセッションに属する処理を待たせる
var checkFirebaseAuthAndDoAction = function (action, companyId, errorHandler) {
    var sessionId = getAuthSessionId();
    var isCurrent = function () { return sessionId === getAuthSessionId(); };
    return ensureFirebaseAuthSession(Firebase.auth(), companyId, sessionId, isCurrent)
        .then(function () {
        if (isCurrent())
            action();
    })
        .catch(function (error) {
        if (!isCurrent())
            return;
        if (process.env.appEnv === 'develop')
            captureException(new Error('Firebaseへのログインに失敗しました'));
        if (errorHandler)
            errorHandler(error);
        else
            throw error;
    });
};
export default checkFirebaseAuthAndDoAction;
